import React, { useState } from 'react';
import { QuestionnaireContainer } from '../../../components/Cards/Report/Questionnaire/Sections/Questionnaire';
import { useQuestionnaireReponse } from '../../../contexts/questionnaireResponse';
import { Item } from '../../Report/Questionnaire';
import QuestionnaireResponseProvider from '../../Providers/QuestionnnaireResponse';
import { useDataApi } from '../../../modules/unsw-hooks';
import { IQuestionnaireResponse } from '../../../modules/unsw-fhir/QuestionnaireResponse';
import { getQuestionnaireResponsesByPatientId } from '../../../apis/questionnaireResponse';
import { usePatient } from '../../../contexts/patient';
import { Spinner, Row, Col } from 'reactstrap';
import { usePractitioner } from '../../../contexts/practitioner';
import MyChoicesReportComponent from '../../../components/Cards/Report/MyChoices';
import { getQuestionnaires } from '../../../apis/questionnaire';
import { IQuestionnaire } from '../../../modules/unsw-fhir/Questionnaire';
const NoQuestionnaireResponses = () => {
  return (
    <Row className="text-center">
      <Col>
        <p>No Questionnaire Responses Found</p>
      </Col>
    </Row>
  );
};

const ResponsesLoading = () => {
  return (
    <Row className="text-center">
      <Col>
        <p>Loading Questionnaire Responses</p>
        <Spinner />
      </Col>
    </Row>
  );
};

const Questionnaire = ({ tabId }: { tabId?: string }) => {
  const { questionnaireResponse, questionnaire, questionnaireResponseLoading } =
    useQuestionnaireReponse();
  if (!questionnaireResponse || !questionnaire) {
    return null;
  }
  const { title = '' } = questionnaire;
  return (
    <QuestionnaireContainer
      loading={questionnaireResponseLoading}
      tabId={tabId || '0'}
      title={title}>
      {questionnaireResponse.item.map(item => (
        <Item key={item.linkId} item={item} />
      ))}
    </QuestionnaireContainer>
  );
};

const MyChoiceCard = ({ onComplete }: { onComplete: () => void }) => {
  const patientContext = usePatient();
  const { getDisplayName } = usePractitioner();
  const [questionnaireResponses] = useDataApi<IQuestionnaireResponse[]>(
    getQuestionnaireResponsesByPatientId,
    [],
    patientContext.patient && patientContext.patient.id,
  );
  const [questionnaires] = useDataApi<IQuestionnaire[]>(
    getQuestionnaires,
    [],
    patientContext.patient && patientContext.patient.id,
  );
  // These variables are passed as props down the tree to handle modal open/close
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <MyChoicesReportComponent
      practitionerDisplayName={getDisplayName()}
      patientContext={patientContext}
      questionnaireResponses={questionnaireResponses}
      questionnaires={questionnaires}
      onComplete={onComplete}
      show={show}
      handleClose={handleClose}
      handleShow={handleShow}>
      {patientContext.loading || questionnaireResponses.isLoading ? (
        <ResponsesLoading />
      ) : questionnaireResponses.data.length > 0 ? (
        questionnaireResponses.data.map(
          (response, index) =>
            response.id && (
              <QuestionnaireResponseProvider
                key={index.toString()}
                questionnaireResponseId={response.id}
                questionnaireResponse={response}>
                <Questionnaire tabId={index.toString()} />
              </QuestionnaireResponseProvider>
            ),
        )
      ) : (
        <NoQuestionnaireResponses />
      )}
    </MyChoicesReportComponent>
  );
};

export default MyChoiceCard;
